<template>
    <div
        class="dk-accordion"
        :class="{
            'tw-text-white': isNegative,
            'tw-border-b tw-border-solid tw-border-slate-100': hasBorders && !isVehicleCard,
            'tw-mt-4': isVehicleCard,
        }"
    >
        <button
            type="button"
            class="dk-accordion__button tw-flex tw-items-center tw-w-full tw-font-semibold tw-py-4 tw-cursor-pointer"
            :class="{
                'body-md': isLarge,
                'hover:tw-text-slate-300': isNegative && !isAccordionCard,
                '!tw-w-fit !tw-justify-start tw-text-brand-primary tw-text-sm !tw-p-0 tw-font-semibold': isVehicleCard,
                '!tw-pt-3 !tw-pb-4 lg:!tw-pt-[22px] lg:!tw-pb-6': isAccordionCard && isExpanded,
                '!tw-py-2': isAccordionCard && !isExpanded,
                'lg:tw-py-3': isVersionCard,
                'lg:tw-pt-3 lg:tw-pb-6': isVersionCard && isExpanded,
            }"
            @click="toggle($event)"
        >
            <span v-if="$slots.title">
                <slot name="title"></slot>
            </span>
            <span v-else :class="{ 'tw-mr-2': isVehicleCard, 'tw-mr-3': !isVehicleCard }" v-html="title"></span>
            <dk-icon
                class="tw-ml-auto"
                :class="{
                    'tw-rotate-180': isExpanded,
                    'tw-mr-4 lg:tw-mr-6': isAccordionCard && !isVersionCard,
                }"
                name="ds-chevron-down"
                :size="isVehicleCard ? 'xs' : isVersionCard ? 'm' : 's'"
            />
        </button>

        <div
            v-if="hasContent"
            class="dk-accordion__content"
            :class="{
                'tw-hidden': !isExpanded,
                'tw-mb-4': hasBorders,
                'tw-mt-[20px]': isVehicleCard,
            }"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script>
import DkIcon from '@v4/common/components/atoms/DkIcon.vue';

export default {
    name: 'DkAccordionDST',
    components: {
        DkIcon,
    },
    props: {
        /**
         * The title of the accordion.
         */
        title: {
            type: String,
            default: '',
        },
        /**
         * Specifies if the accordion should be expanded by default or not.
         */
        expanded: {
            type: Boolean,
            default: false,
        },
        /**
         * Sets a larger size of te accordion trigger button
         */
        isLarge: {
            type: Boolean,
            default: false,
        },
        /**
         * Sets the negative styles (light on dark background)
         */
        isNegative: {
            type: Boolean,
            default: false,
        },
        /**
         * Whether the top-bottom  borders are shown
         */
        hasBorders: {
            type: Boolean,
            default: true,
        },
        /**
         * Flag to apply custom styles to the accordion
         * in the vehicle card on Search page.
         */
        isVehicleCard: {
            type: Boolean,
            default: false,
        },
        /**
         * Specifies if the accordion or its parts
         * should have particular hover styles.
         */
        isAccordionCard: {
            type: Boolean,
            default: false,
        },
        /**
         * Specifies if the accordion or its parts
         * should have particular hover styles.
         */
        isVersionCard: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isExpanded: false,
        };
    },
    computed: {
        hasContent() {
            return !!this.$slots.default;
        },
    },
    watch: {
        expanded(newValue) {
            this.isExpanded = newValue;
        },
    },
    created() {
        this.isExpanded = this.expanded;
    },
    methods: {
        /**
         * Toggles the accordion when the title is clicked.
         *
         * @returns {undefined}
         *
         * @public
         */
        toggle() {
            this.isExpanded = !this.isExpanded;
            if (this.isAccordionCard) {
                this.$emit('click-expanded', this.isExpanded);
            }
        },
    },
};
</script>
